module.exports = __webpack_public_path__ + "img/menu_line.d900e2fe.svg";